import { supabase } from "./core.js";

interface SendReportParams {
  client_id: string;
  period: string;
}

export async function invokeSendMonthlyReport(params: SendReportParams): Promise<unknown> {
  const { data, error } = await supabase.functions.invoke("send-monthly-report", {
    body: params,
  });
  if (error) throw error;
  return data;
}

export async function sendWelcomeEmail(
  email: string,
  nome: string,
  clientId: string
): Promise<unknown> {
  const {
    data: { session },
  } = await supabase.auth.getSession();
  const response = await fetch("/api/send-welcome-email", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${session?.access_token ?? ""}`,
    },
    body: JSON.stringify({ email, nome, clientId }),
  });
  return response.json();
}
